export default __webpack_public_path__ + "static/media/AdWarriors_05.0860be15.png";